module.exports = {
  "country": "ES",
  "artist": "Nebulossa",
  "song": "Zorra",
  "year": "2024",
  "place": "22",
  "spotify": "4ypCNolz6aRYZPO3UOGp8Z"
};